const Prod_BaseUrl = process.env.REACT_APP_BACKEND_PROD_URL;
const Stage_BaseUrl = process.env.REACT_APP_BACKEND_STAGE_URL;
const local_BaseUrl = process.env.REACT_APP_BACKEND_LOCAL_URL

const environments = {
  stage: Stage_BaseUrl,
  prod: Prod_BaseUrl,
  local: local_BaseUrl
};

const activeEnvironment = environments.prod;

const apiUrl = {
  fetchIpData: activeEnvironment + "/fetch-ip-data",
  contactUs: activeEnvironment + "/add_contact",
  saveRegistrationInfo: activeEnvironment + "/save-registration-info",
  savePartnerInfo: activeEnvironment + "/submit_partner_info",
  saveStudentLEadInfo: activeEnvironment + "/student-placement-request",
};

export default apiUrl;
